import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-love",
  "use": "rt-portal-love-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-portal-love\"><defs><style type=\"text/css\"></style></defs><path d=\"M284.7 894.19a30.57 30.57 0 0 1-30.15-35.68L294.88 620 121.29 451.61a30.58 30.58 0 0 1 16.82-52.2l239.27-35.33 106.53-217.16a30.57 30.57 0 0 1 27.37-17.12h0.07a30.55 30.55 0 0 1 27.38 17l107.58 216.63 239.44 34.21a30.57 30.57 0 0 1 17.07 52.1L730 619l41.44 238.3a30.59 30.59 0 0 1-44.29 32.35L512.83 777.57 299 890.64a30.41 30.41 0 0 1-14.3 3.55z\" p-id=\"3415\" fill=\"#f5222d\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/love.svg
// module id = 690
// module chunks = 99